import makeErrorFromUnknown from '@/functions/makeErrorFromUnknown';
import {
  BaseError,
  CoreAppGeneralError,
} from '@/modules/errors/constants/error-class-map.gen';

export default function castErrorToBaseError(error: unknown) {
  if (error instanceof BaseError) return error;
  return new CoreAppGeneralError(makeErrorFromUnknown(error));
}
